import React from 'react'
import {Col, Row, Space} from "antd";

const ProgressBar = ({
percentage,
    label
})=>{

    return <Space className={'font-sm'}>
        {
            `${percentage}% `
        }
        {
            label
        }
        <Row style={{width:240,height:8}}>
        <Col
        className={'primary-bg'}

        style={{flex:percentage/100}}
        >

        </Col>
            <Col
            className={'white30-bg'}
            style={{flex:(100-percentage)/100}}
            >
            </Col>
        </Row>
    </Space>
}

export default ProgressBar